import styled, { css } from 'styled-components'
import { _placeholder } from '../../utils/mixins'

export const StyledLabel = styled.div<{ warning?: boolean; error?: boolean }>`
  font-size: ${({ theme }) => theme.fontSize.xxs};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.space.xs};

  ${({ warning }) =>
    warning &&
    css`
      color: #d87515;
      margin-top: ${({ theme }) => theme.space.xxs};

      span {
        svg {
          margin-left: 0;
          margin-right: ${({ theme }) => theme.space.xxs};
        }
      }
    `}

  ${({ error }) =>
    error &&
    css`
      color: ${({ theme }) => theme.colors.uiError};
      margin-top: ${({ theme }) => theme.space.xxs};

      span {
        svg {
          margin-left: 0;
          margin-right: ${({ theme }) => theme.space.xxs};
        }
      }
    `}

  span {
    svg {
      margin-left: ${({ theme }) => theme.space.xxs};
    }
  }
`

export const StyledInput = styled.div<{ warning?: boolean; error?: boolean }>`
  input {
    border: 1px solid ${({ theme }) => theme.palette.gray100};
    padding: ${({ theme }) => theme.space.xs};
    ${_placeholder(css`
      font-weight: ${({ theme }) => theme.fontWeight.regular};
    `)}

    ${({ warning }) =>
      warning &&
      css`
        border: 1px solid ${({ theme }) => theme.palette.warning100};
      `}

    ${({ error }) =>
      error &&
      css`
        border: 1px solid ${({ theme }) => theme.palette.danger100};
      `}
  }
`
